export enum ExportType {
  PDF = 'PDF',
  TRANSLATION_PACKAGE = 'TranslationPackage',
  HTML_PACKAGE = 'HtmlPackage',
  IPAD_PACKAGE = 'IPadPackage',
}
